import Axios from 'axios';
import { inflate, gzip } from 'pako';

// ========================================
// BASIC S3 OPERATIONS
// ========================================

export const uploadToS3 = (url, file) => Axios.put(url, file);

export const getFromS3 = (url) => Axios.get(url);

// ========================================
// GZIP OPERATIONS FOR S3
// ========================================

/**
 * Downloads a gzipped file from S3 and decompresses it to text
 * @param {string} url - The S3 URL to download from
 * @returns {Promise<string>} The decompressed text content
 */
export const downloadGzipText = async (url) => {
    const response = await Axios.get(url, { responseType: 'arraybuffer' });
    const compressed = new Uint8Array(response.data);
    return inflate(compressed, { to: 'string' });
};

/**
 * Compresses text with gzip and uploads it to S3
 * @param {string} url - The S3 URL to upload to
 * @param {string} text - The text content to compress and upload
 * @returns {Promise<void>}
 */
export const uploadGzipText = async (url, text) => {
    const compressed = gzip(text);
    return Axios.put(url, compressed, {
        headers: {
            'Content-Type': 'application/gzip',
        },
    });
};
